import { useEffect, useState } from "react";
import {
  CompanyManageMyCompany,
  CompanyManageMyStoreMyStoreCompany,
  OfferPriceHistoryPriceOffer,
} from "../../Api/Services";
import imgPlus from "../../assets/Icon/pluse.png";
import { useNavigate } from "react-router-dom";
import InputCus from "../../Component/InputCus/Text/InputCus";

function PriceOffer() {
  const [Data, setData] = useState();
  const [MyStore, setMyStore] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [Company, setCompany] = useState([]);
  const [ActiveCompany, setActiveCompany] = useState();
  const [SearchName, setSearchName] = useState("");

  const navigate = useNavigate();

  const start = async () => {
    setCompany([]);
    try {
      const CompanyManageMyCompanysData = await CompanyManageMyCompany();
      if (
        CompanyManageMyCompanysData.status &&
        CompanyManageMyCompanysData.status === 200
      ) {
        setCompany(CompanyManageMyCompanysData.data.data);
        if (CompanyManageMyCompanysData.data.data.length > 0) {
          let id = CompanyManageMyCompanysData.data.data[0].companyId;
          setActiveCompany(id);
          const OfferPriceHistoryPriceOfferData =
            await OfferPriceHistoryPriceOffer(id);
          if (
            OfferPriceHistoryPriceOfferData.status &&
            OfferPriceHistoryPriceOfferData.status === 200
          ) {
            setData(OfferPriceHistoryPriceOfferData.data.data.data);

            const CompanyManageMyStoreMyStoreCompanyData =
              await CompanyManageMyStoreMyStoreCompany(id);
            if (
              CompanyManageMyStoreMyStoreCompanyData.status &&
              CompanyManageMyStoreMyStoreCompanyData.status === 200
            ) {
              setMyStore(CompanyManageMyStoreMyStoreCompanyData.data.data);
            }
          }
        }
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  const SetCompany = async (id) => {
    setActiveCompany(id);
    setLoading(true);
    try {
      const OfferPriceHistoryPriceOfferData =
        await OfferPriceHistoryPriceOffer(id);
      if (
        OfferPriceHistoryPriceOfferData.status &&
        OfferPriceHistoryPriceOfferData.status === 200
      ) {
        setData(OfferPriceHistoryPriceOfferData.data.data.data);

        const CompanyManageMyStoreMyStoreCompanyData =
          await CompanyManageMyStoreMyStoreCompany(id);
        if (
          CompanyManageMyStoreMyStoreCompanyData.status &&
          CompanyManageMyStoreMyStoreCompanyData.status === 200
        ) {
          setMyStore(CompanyManageMyStoreMyStoreCompanyData.data.data);
        }
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    start();
  }, []);

  const Add = () => {
    navigate("/Panel/PriceOfferAE");
  };

  const groupProducts = (products) => {
    const groups = {};
    products.forEach((p) => {
      const key = [
        p.productBerandId,
        p.productTypeId,
        p.productSeriesId,
        p.symbol,
        p.productSeriesEndId,
        p.productRamId,
        p.productRomId,
        p.productNetworkId,
        p.productCountryId,
        p.isInsurance,
      ].join("-");
      if (!groups[key]) {
        groups[key] = [];
      }
      groups[key].push(p);
    });
    return Object.values(groups);
  };

  return (
    <div>
      {isLoading && (
        <div className="d-flex justify-content-center align-items-center">
          <div className="lds-facebook">
            <div />
            <div />
            <div />
          </div>
        </div>
      )}
      <div className={isLoading ? "startLoading" : "stateLoading"}>
        <div className="w-100 d-flex justify-content-start align-items-start flex-column element p-5">
          <div className="d-flex justify-content-start align-items-center w-100 mb-5 pointer">
            <img
              onClick={() => {
                Add();
              }}
              src={imgPlus}
              alt=""
            />
          </div>
          <div className="d-flex justify-content-between align-items-center">
            {Company &&
              Company.map((item, key) => (
                <button
                  onClick={() => {
                    SetCompany(item.companyId);
                  }}
                  className={`m-2 border rounded-5 h6 ps-3 pe-3 pt-1 pb-2 ${
                    ActiveCompany == item.companyId ? "bg-warning" : ""
                  }`}
                >
                  {item.companyName}
                </button>
              ))}
          </div>
          <InputCus
            className="m-2"
            type="text"
            name="name"
            id="name"
            text="نام"
            value={SearchName}
            onChange={(e) => {
              setSearchName(e.target.value);
            }}
          />
          {Data && (
            <div className="d-flex justify-content-center align-items-center w-100 tableC">
              <table
                className="table tableMore"
                style={{ lineHeight: "normal" }}
              >
                <thead className="sticky-header">
                  <tr className="trTable">
                    <th>سیمبل کالای</th>
                    <th>رنگ</th>
                    <th>انبار</th>
                    <th>قیمت پیشنهادی</th>
                  </tr>
                </thead>

                {Data.filter((w) => w.companyStoreOfferPrices.length > 0) &&
                  groupProducts(
                    Data.filter((w) => w.companyStoreOfferPrices.length > 0),
                  ).map((group, gIndex) => (
                    <tbody
                      key={gIndex}
                      style={{
                        backgroundColor:
                          gIndex % 2 === 0 ? "#ffffff" : "#e6f0ff",
                      }}
                    >
                      {group
                        .filter((itemPro) => {
                          const productFilter =
                            SearchName?.toUpperCase?.() || "";
                          const Pro =
                            (
                              (itemPro.productBerandName != " " &&
                                itemPro.productBerandName + " ") +
                              (itemPro.productTypeName != " " &&
                                itemPro.productTypeName + " ") +
                              (itemPro.productSeriesName != " " &&
                                itemPro.productSeriesName) +
                              itemPro.symbol +
                              (itemPro.productSeriesEndName != " "
                                ? itemPro.productSeriesEndName + " "
                                : " ") +
                              (itemPro.productRamName != " " &&
                                itemPro.productRamName + "/") +
                              (itemPro.productRomName != " " &&
                                itemPro.productRomName + " ") +
                              (itemPro.productNetworkName != " " &&
                                itemPro.productNetworkName + " ") +
                              (itemPro.productCountryName != " " &&
                                itemPro.productCountryName + " ") +
                              (itemPro.isInsurance && "بیمه")
                            )?.toUpperCase?.() || "";
                          return Pro.includes(productFilter);
                        })
                        .map((itemPro, iIndex) => {
                          return (
                            <>
                              {MyStore.map((store, sIndex) => (
                                <tr
                                  key={`${itemPro.id}-${store.companyStoreId}`}
                                >
                                  {iIndex === 0 && sIndex === 0 && (
                                    <td rowSpan={group.length * MyStore.length}>
                                      {itemPro.productBerandName != " " &&
                                        itemPro.productBerandName + " "}
                                      {itemPro.productTypeName != " " &&
                                        itemPro.productTypeName + " "}
                                      {itemPro.productSeriesName != " " &&
                                        itemPro.productSeriesName}
                                      {itemPro.symbol}
                                      {itemPro.productSeriesEndName != " "
                                        ? itemPro.productSeriesEndName + " "
                                        : " "}
                                      {itemPro.productRamName != " " &&
                                        itemPro.productRamName + "/"}
                                      {itemPro.productRomName != " " &&
                                        itemPro.productRomName + " "}
                                      {itemPro.productNetworkName != " " &&
                                        itemPro.productNetworkName + " "}
                                      {itemPro.productCountryName != " " &&
                                        itemPro.productCountryName + " "}
                                      {itemPro.isInsurance && "بیمه"}
                                    </td>
                                  )}
                                  {sIndex === 0 && (
                                    <td rowSpan={MyStore.length}>
                                      {itemPro.productColorName}
                                    </td>
                                  )}
                                  <td>{store.companyStoreName}</td>
                                  <td>
                                    {itemPro.companyStoreOfferPrices
                                      .find(
                                        (w) =>
                                          w.companyStoreId ===
                                          store.companyStoreId,
                                      )
                                      ?.price?.toString()
                                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",") ||
                                      "-"}
                                  </td>
                                </tr>
                              ))}
                            </>
                          );
                        })}
                    </tbody>
                  ))}
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default PriceOffer;
